import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { currentLang } from '../../../utils/functions';

const NoticeBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if the banner was previously dismissed
    const dismissed = localStorage.getItem('noticeBannerDismissed');
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);

  // Only show banner for Dutch (NL) and German (DE) websites
  if (currentLang() !== 'nl' && currentLang() !== 'de') {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
    // Store the dismissal in localStorage so it persists across sessions
    localStorage.setItem('noticeBannerDismissed', 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="notice-banner">
      <div className="container">
        <div className="notice-banner__content">
          <div className="notice-banner__text">
            {parse(t('notice_banner.text'))}
          </div>
          <button 
            className="notice-banner__close" 
            onClick={handleClose}
            aria-label="Sluiten"
          >
            <span>&times;</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeBanner; 